import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localToUtc'
})
export class LocalToUtcTransformPipe implements PipeTransform {
    transform(dateString: string, format: string): any {

        // return if input date is null or undefined
        if (!dateString) {
            return;
        }

        // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
        if (dateString.indexOf('T') === -1 && dateString.indexOf('Z') === -1 && dateString.indexOf('+') === -1) {
            dateString += 'Z';
        }


        //let d = new Date(dateString);
        //// convert and format date 
       // return d.toUTCString();

        return new DatePipe('en-US').transform(dateString, format, "UTC");
    };
}
